import Translated from '../Translated';
import { useTranslation } from '../TranslationProvider';

export const hasAssessmentSummary = assessment => Boolean(assessment?.localizationKeys && Array.isArray(assessment?.topics));

const AssessmentSummary = ({ assessment }) => {
  const { translate } = useTranslation();
  if (!hasAssessmentSummary(assessment)) {
    return null;
  }

  const keys = assessment.localizationKeys;
  return (
    <div className="blue-box text-start mb-3" id={`${assessment.type}-assessment-summary`}>
      <h3><Translated translationKey={assessment.isPassed ? keys.passed : keys.failed} /></h3>
      <p><Translated translationKey={keys.totalResult} values={{ correct: assessment.correctAmount, total: assessment.totalQuestionAmount, required: assessment.totalPassLimit }} /></p>
      {assessment.topics.map(topic => (
        <div key={topic.id} className={topic.isPassed ? 'accepted' : 'rejected'}>
          <strong><Translated translationKey={topic.localizationKey} /></strong>: <Translated translationKey={keys.topicResult} values={{ correct: topic.correctAmount, total: topic.questionAmount, required: topic.passLimit, status: translate(topic.isPassed ? keys.topicPassed : keys.topicFailed) }} />
        </div>
      ))}
    </div>
  );
};

export const AssessmentQuestionMetadata = ({ question, assessment }) => {
  const topicLocalizationKey = assessment?.topics?.find(topic => topic.id === question.topic)?.localizationKey;
  const labelKey = assessment?.localizationKeys?.topicLabel;
  if (!topicLocalizationKey || !labelKey) {
    return null;
  }

  return (
    <div className="test-result-explanation">
      <strong><Translated translationKey={labelKey} />:</strong>&nbsp;
      <span className="test-result-literal-answer-text"><Translated translationKey={topicLocalizationKey} /></span>
    </div>
  );
};

export default AssessmentSummary;
